var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend01SvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7495 11.2502L17.4995 2.50014M8.85583 11.5235L11.0459 17.1552C11.2388 17.6513 11.3353 17.8994 11.4743 17.9718C11.5948 18.0346 11.7384 18.0347 11.8589 17.972C11.998 17.8998 12.0948 17.6518 12.2883 17.1559L17.7803 3.08281C17.955 2.63516 18.0423 2.41133 17.9945 2.26831C17.953 2.1441 17.8556 2.04663 17.7313 2.00513C17.5883 1.95736 17.3645 2.0447 16.9168 2.21939L2.84373 7.71134C2.34783 7.90487 2.09989 8.00163 2.02763 8.14072C1.96499 8.26128 1.96508 8.40483 2.02786 8.52533C2.10028 8.66433 2.34834 8.76083 2.84446 8.95375L8.47617 11.1438C8.57683 11.183 8.62717 11.2026 8.66958 11.2328C8.70717 11.2596 8.74 11.2925 8.76683 11.3301C8.79708 11.3725 8.81667 11.4228 8.85583 11.5235Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend01SvgrepoCom);
export default __webpack_public_path__ + "static/media/send-01-svgrepo-com.479d76969a345d024bbc480cb472b5c8.svg";
export { ForwardRef as ReactComponent };